module.exports = __webpack_public_path__ + "assets/img/free.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/free.png
// module id = 1940
// module chunks = 0